import { render } from "./raceManager.vue?vue&type=template&id=3a0793e4&scoped=true"
import script from "./raceManager.vue?vue&type=script&lang=js"
export * from "./raceManager.vue?vue&type=script&lang=js"

import "./raceManager.vue?vue&type=style&index=0&id=3a0793e4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0793e4"]])

export default __exports__